import ApiService from './api.service'
import { TokenService } from './storage.service'




class CoreError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const CoreService = {
    /**
     * Login the user and store the access token to TokenService. 
     * 
     * @returns access_token
     * @throws AuthenticationError 
    **/








    PlaceOrder: async function (name, amount, phoneNo, FlutterRef, refferNo, EmailAddress) {
        console.log(FlutterRef);
        ////console.log(quantityw)
        ////console.log(productID)
        const requestData = {
            method: 'post',
            url: "api/v1/core/place",
            data: {

                name: name,

                amount: amount,
                phoneNo: phoneNo,
                FlutterRef: FlutterRef,
                refferNo: refferNo,
               
                EmailAddress: EmailAddress,
              
            }

        }

        try {
            const response = await ApiService.customRequest(requestData)




            return response.data
        } catch (error) {
            throw new CoreError(error.response.status, error.response.data.detail)
        }

    },



    getRecentOrders: async function () {
        const requestData = {
            method: 'get',
            url: "/api/v1/core/orders/" 


        }

        try {

            const response = await ApiService.customRequest(requestData)

            if (response.status == 200) {





                // console.log(response.data);


                return response.data

            }

            //else {
            //    throw new OrderError(error.response.status, error.response.data.errors[0])

            //}
        } catch (error) {

            if (error.response.status == 401) {

                TokenService.saveToken('')
                TokenService.saveRefreshToken('')
                ApiService.setHeader()
                //router.push({
                //    name: '/login',
                //    query: {
                //        redirect: '/orders'
                //    }
                //});
            }
            else {
                throw new CoreError(error.response.status, error.response.data.errors[0])
            }

            // alert(error.response.status);
        }
    },




   





}

export default CoreService

export { CoreService, CoreError }